import { createFormHook } from '@tanstack/react-form';

import {
  FormGroupPickerInput,
  FormPersonPickerInput,
  FormPhotoInput,
  FormPhotoListInput,
} from './CollectionFields';
import {
  FormDateInput,
  FormDateRangeInput,
  FormEmailInput,
  FormPasswordInput,
  FormPlaceAutocomplete,
  FormTextInput,
} from './Fields';
import { FormSubmitBigButton, FormSubmitButton } from './SubmitButton';
import { fieldContext, formContext, useFieldContext } from './context';

const appForm = createFormHook({
  fieldComponents: {
    DateInput: FormDateInput,
    DateRangeInput: FormDateRangeInput,
    EmailInput: FormEmailInput,
    GroupPickerInput: FormGroupPickerInput,
    PasswordInput: FormPasswordInput,
    PersonPickerInput: FormPersonPickerInput,
    PhotoInput: FormPhotoInput,
    PlaceAutocomplete: FormPlaceAutocomplete,
    PhotoListInput: FormPhotoListInput,
    TextInput: FormTextInput,
  },
  fieldContext,
  formComponents: {
    SubmitBigButton: FormSubmitBigButton,
    SubmitButton: FormSubmitButton,
  },
  formContext,
});

export const { useAppForm, useTypedAppFormContext, withFieldGroup, withForm } = appForm;
export { createStringValidator } from './validators';
export { getErrorText } from './errors';
export { FormSectionTitle } from './SectionTitle';
export { SelectedImagePreview } from './SelectedImagePreview';
export { MultiStepFormWizard } from './MultiStepFormWizard';
export { FormSubmitBigButton, FormSubmitButton, submitFormSafely } from './SubmitButton';
export { useFieldContext };
export type { SelectedImagePreviewProps } from './SelectedImagePreview';
export type { StringFieldProps } from './Fields';
export type { FormSubmitButtonProps, FormSubmitter } from './SubmitButton';
export type {
  MultiStepFormWizardForm,
  MultiStepFormWizardProps,
  MultiStepFormWizardStep,
} from './MultiStepFormWizard';
